<template>
    <div  class="all-height">
        <el-main class="all-height" v-if="flag">
            <div class="operation-bar">
                <h1>发货管理</h1>
                <div class="operation-bar-right">
                    <div class="input-box">
                        <i class="el-icon-search" @click="queryByKeyword"></i>
                        <input type="text" v-model="keyword" placeholder="请输入订单号或发货单号"/>
                    </div>
                    <a href="javascript:void(0)" @click="delSend">删除</a>
                </div>
            </div>

            <div class="table-box cursorPointer">
                <el-table :data="sendList"
                          ref = "tb"
                          height="calc(100% - 55px)"
                          :highlight-current-row = 'true'
                          :header-cell-style="{background:'#4885CA',color: 'white'}"
                          @row-dblclick = "rowDblclick"
                          @select-all = "selectAll"
                          @row-click="rowClick"
                          @select="select"
                >
                    <el-table-column width="50" type="selection" header-align="center" align="center"></el-table-column>
                    <el-table-column width="150px" prop="sendNo" label="发货单号" header-align="center" align="center" :show-overflow-tooltip="true">
                    </el-table-column>
<!--                    <el-table-column width="150px" prop="sapInvoiceNo" label="内向交货单号" header-align="center" align="center" :show-overflow-tooltip="true">-->
<!--                    </el-table-column>-->
<!--                    <el-table-column width="200px" prop="orderNo" label="订单编号" header-align="center" align="center" :show-overflow-tooltip="true">-->
<!--                    </el-table-column>-->
                    <el-table-column width="250"  prop="createUser" label="制单人" header-align="center" align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column width="150px"  prop="createTime" label="制单日期" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column width="150px"  prop="sendDate" label="预计发货日期" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column width="150px"  prop="expectDate" label="预计到货日期" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column width="250px"  prop="vendorName" label="供应商名称" header-align="center" align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column  label="状态" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-tag  type="primary" v-if="scope.row.status === 0">未提交</el-tag>
                            <el-tag  type="success" v-else>已提交</el-tag>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="table-page">
                    <el-pagination
                            @size-change="changePageSize"
                            @current-change="changeCurrentPage"
                            :current-page="page.current"
                            :page-sizes="page.pageSizes"
                            :page-size="page.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="page.total">
                    </el-pagination>
                </div>
            </div>

            <!--修改用户弹出框-->
            <el-dialog
                    :title="sendDiaLog.title"
                    :visible.sync="sendDiaLog.isShow"
                    width="30%"
                    @close="closeDialog"
            >
                <el-form ref="form" :model="form" label-width="100px">
                    <el-form-item label="订单编号" prop="orderNo">
                        <el-select style="width: 100%" v-model="form.orderNo" placeholder="请选择订单编号" >
                            <el-option
                                    v-for="item in noSendOrderList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="预计发货日期:" prop="sendDate">
                        <el-date-picker
                                style="width: 100%"
                                v-model="form.sendDate"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="请输入预计发货日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="预计到货日期:" prop="expectDate">
                        <el-date-picker
                                style="width: 100%"
                                v-model="form.expectDate"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="请输入预计发货日期">
                        </el-date-picker>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="closeDialog">取 消</el-button>
                    <el-button type="primary" @click="submitForm">确定</el-button>
                </div>
            </el-dialog>
        </el-main>

        <send-detail :to-comp="toComp" :order-no="orderNo" :sendId = "sendId" :is-lock="isLock"  @closeSendDetail="closeDetail"  v-else></send-detail>
    </div>

</template>

<script>
    import {mapState} from 'vuex';
    import sendDetail from './send-detail';
    export default {
        name: 'send',
        components: {
            sendDetail
        },
        data() {
            return {
                currentRow: null,
                keyword: '',
                orderNo: '',
                toComp: '',
                sendId: '',
                sendDiaLog: {
                    title: '',
                    isShow: false
                },
                form: {
                    orderNo: '',
                    sendDate: '',
                    expectDate: ''

                },
                noSendOrderList: [],
                flag: true,
                isLock: false
            };
        },
        computed: {
            ...mapState('send/send', ['page', 'sendList'])
        },
        methods: {
            query() {
                this.$store.dispatch('send/send/getSendList', this.$route.query.orderNo!=null?this.$route.query.orderNo:this.keyword);
                this.$route.query.orderNo = null;
            },
            queryByKeyword() {
                this.$store.commit('send/send/SET_PAGE_CURRENT', 1);
                this.query();
            },
            modifyFlag() {
                this.flag = !this.flag;
            },
            rowDblclick(row) {
                this.flag = !this.flag;
                this.orderNo = row.orderNo;
                this.toComp = row.toComp;
                this.sendId = row.id;
                if(row.status === 0){
                    this.isLock = false;
                }else{
                    this.isLock = true;
                }
            },
            selectAll() {
                this.$refs.tb.clearSelection();
                this.currentRow = null;
            },
            select(selection, row) {
                this.$refs.tb.clearSelection();
                this.$refs.tb.toggleRowSelection(row);
                this.currentRow = row;
            },
            rowClick(row) {
                this.$refs.tb.clearSelection();
                this.$refs.tb.toggleRowSelection(row);
                this.currentRow = row;
            },
            delSend() {
                if(this.currentRow){
                    this.$store.dispatch('send/send/deleteSend', {id: this.currentRow.id}).then((ret)=>{
                        if(ret.code === '200'){
                            this.query();
                        }else{
                            this.$message.error(ret.data?ret.data : ret.message);
                        }
                    })
                }else{
                    this.$message.error("请选择要删除的行");
                }
            },
            submitForm() {
                this.$store.dispatch('send/send/saveSend', this.form).then((res)=>{
                    if(res.code === '200') {
                        this.$message.success("保存成功");
                        this.sendDiaLog.isShow = false;
                        this.query();
                    }else{
                        this.$message.error(res.data?res.data : res.message);
                    }
                })
            },
            closeDialog() {
                this.sendDiaLog.isShow = false;
            },
            closeDetail(isSubmit) {
                this.modifyFlag();
                if(isSubmit){
                    this.query();
                }
            },
            changePageSize(val) {
                this.$store.commit('send/send/SET_PAGE_SIZE', val);
                this.query();
            },
            changeCurrentPage(val) {
                this.$store.commit('send/send/SET_PAGE_CURRENT', val);
                this.query();
            },
        },
        created() {
            this.query();
        }
    }

</script>

<style scoped>
    .table-box{
        position: relative;
        margin-top: 5px;
        background-color: white;
        height: calc(100% - 35px);
        width: 100%;
    }
    .table-page {
        width: 100%;
        text-align: center;
        position: absolute;
        bottom: 10px;
    }
    .el-table .el-button{
        padding: 0;
    }
    .cell i {
        font-size: 25px;
        cursor: pointer;
    }
    .cell i:hover {
        color: #5ED1FD;
    }
    .textArea-box {
        max-height: 300px;
        overflow-y: scroll;
    }
    /deep/ .cursorPointer tbody tr:hover {cursor: pointer }
</style>
